import { createContext, useContext, useEffect, useState } from "react";

import useGetFirmLogo from "../Components/FirmSettings/firm-branding/hooks/useGetFirmBranding";

const BrandColorContext = createContext();

export const BrandColorProvider = ({ children }) => {
  const [brandColor, setBrandColor] = useState("#19395f");
  const { data: getFirmLogo, refetch } = useGetFirmLogo();

  const updateBrandColor = (color) => {
    setBrandColor(color);
    document.documentElement.style.setProperty("--brand-color", color);
    localStorage.setItem("firmPrimaryColor", color);
  };

  useEffect(() => {
    if (getFirmLogo?.brand_color) {
      updateBrandColor(getFirmLogo?.brand_color);
    }
  }, [getFirmLogo]);

  useEffect(() => {
    const savedColor = localStorage.getItem("firmPrimaryColor");
    if (savedColor) {
      updateBrandColor(savedColor);
    }
  }, []);

  useEffect(() => {
    const handleLoginSuccess = () => {
      refetch();
    };

    window.addEventListener("user-logged-in", handleLoginSuccess);

    return () => {
      window.removeEventListener("user-logged-in", handleLoginSuccess);
    };
  }, [refetch]);

  return (
    <BrandColorContext.Provider value={{ brandColor, updateBrandColor }}>
      {children}
    </BrandColorContext.Provider>
  );
};

export const useBrandColor = () => {
  const context = useContext(BrandColorContext);
  if (!context) {
    throw new Error("useBrandColor must be used within BrandColorProvider");
  }
  return context;
};
